import React, { useState, useRef, useEffect } from 'react';
import SVGIcon from './svg_icon';

type PopupOptionsProps = {
  children: React.ReactNode;
  IconComponent: React.ComponentType;
};

const ExpandableIconButton: React.FC<PopupOptionsProps> = ({ children, IconComponent }) => {
  const [showOptions, setShowOptions] = useState(false);
  const parentRef = useRef(null);
  const iconRef = useRef(null);
  const subPanelRef = useRef(null);
  const hideTimer = useRef<NodeJS.Timeout | null>(null); // Pour stocker le timeout

  useEffect(() => {
    if (parentRef.current && iconRef.current && subPanelRef.current) {
      const parent = parentRef.current;
      const icon = iconRef.current;
      const subPanel = subPanelRef.current;

      const iconWidth = icon.getBoundingClientRect().width;
      const subPanelWidth = subPanel.getBoundingClientRect().width;

      parent.style.width = `${showOptions ? iconWidth + subPanelWidth : iconWidth}px`;
    }
  }, [showOptions]);

  const handleMouseLeave = () => {
    // On déclenche le timeout après 1 seconde (1000ms)
    hideTimer.current = setTimeout(() => {
      setShowOptions(false);
    }, 200);
  };

  const handleMouseEnter = () => {
    // Si le timeout est en cours, on le stoppe
    if (hideTimer.current) {
      clearTimeout(hideTimer.current);
    }
    setShowOptions(true);
  };

  return (
    <div
      ref={parentRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className="relative h-40"
    >
      <div ref={iconRef} className={`bg-sky-700 popup-option-icon ${showOptions ? 'show' : ''}`}>
        <SVGIcon IconComponent={IconComponent} />
      </div>
      
      <div ref={subPanelRef}  className={`options-container ${showOptions ? 'show' : ''}`}>
        <div className="bg-white rounded-full p-1 h-[64px]  flex items-center pl-14 pr-4  flex-shrink-0">
          {children}
        </div>
      </div>
    </div>
  );
};

export default ExpandableIconButton;
